/*
 * @Author: DWP
 * @Date: 2020-07-27 16:59:17
 * @LastEditors: Dong
 * @LastEditTime: 2021-09-14 13:45:54
 */
import React from 'react';
import { render } from 'react-dom';
import 'sup-ui/dist/sup-ui.less';
import App from './App';
import './index.css';

render(<App />, document.getElementById('root'));

if (module.hot) {
  module.hot.accept('./router', () => {
    render(<App />, document.getElementById('root'));
  });
}
